import ApplicationsListPage from '../pages/applications-list.vue'
import ApplicationBuilderPage from '../pages/[setId].vue'

/**
 * Application builder routes (tickets/2617). Both pages are tenant-scoped and
 * authenticated; the list replaces the legacy Rails `/applications` admin and
 * receives its redirected traffic.
 */
export default [
  {
    component: ApplicationsListPage,
    name: 'applications.list',
    path: '/:slug/applications',
    meta: { title: 'Entrepreneur Applications — Venture360', migratedDesign: true },
  },
  {
    component: ApplicationBuilderPage,
    name: 'applications.builder',
    path: '/:slug/applications/:setId(\\d+)',
    meta: { title: 'Application — Venture360', migratedDesign: true },
  },
]
